<template>
  <div class="login container">
    <form v-if="!confirmationResults" @submit.prevent="login" class="card-panel">
      <h2 class="center deep-purple-text">Login</h2>  
      <div class="field">
          <label for="phonenumber">Phone Number:</label>
          <input 
          type="phonenumber" 
          name="phonenumber" 
          v-model="phonenumber">
       </div>
        <p v-if="feedback" class="red-text center">{{ feedback }}</p>
        <div class="field center">
          <button id="loginbtn" class="btn deep-purple">Login</button>
        </div>
    </form> 
    <form v-if="confirmationResults" @submit.prevent="finalLogin" class="card-panel">
      <div class="field">
          <label for="code">Verification Code:</label>
          <input type="code" name="code" v-model="code">
      </div>
      <p v-if="feedback" class="red-text center">{{ feedback }}</p>
      <div class="field center">
          <button id="verifybtn" class="btn deep-purple">Login</button>
      </div>
    </form>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Login',
  data () {
    return {
      phonenumber: "+1 ",
      confirmationResults: null,
      code: null,
      feedback: null
    }
  },
  methods: {
    login(){
      if(this.phonenumber){
        firebase.auth().signInWithPhoneNumber(this.phonenumber,window.recaptchaVerifier)
        .then((confirmationResult) => {
          console.log("confirmation of login after captcha", confirmationResult)
          this.confirmationResults = confirmationResult
        }).catch(err => {
          this.feedback = err.message
        })
        this.feedback = null
      } else {
          this.feedback = "Something went wrong"
      }
    },
    finalLogin(){
      let vm = this
      if(this.code){
        this.confirmationResults.confirm(this.code)
        .then((result) => {
          console.log("signed in", result.user)
          vm.$router.push({ name: 'ScenarioStart' })
        }).catch((error) => {
          console.error(error)
        })
        this.feedback = null
      } else {
          this.feedback = "Code is wrong"
      }
    }
  },
  mounted() {
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      'loginbtn', {
        'size': 'invisible',
        'callback': function(response) {
        }
      }
    )
  }
}
</script>

<style scoped>
.login{
  max-width: 400px;
  margin-top: 60px;
  text-align: start;
  }
.login h2{
  font-size: 2.4em;
}
.login .field{
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/Login.vue